import { useCallback, useRef } from 'react'
import { useBoolean } from 'react-use'
import type { RefObject } from 'react'
import type { GroupBase, SelectComponentsConfig } from 'react-select'
import { LoadFailedNoOptionsMessage } from './LoadFailedNoOptionsMessage'

export type UseLoadOptionsFailureResult = {
  onLoadSettled: (failed: boolean) => void
  latestRequest: RefObject<number>
  components?: SelectComponentsConfig<any, boolean, GroupBase<any>>
}

export const useLoadOptionsFailure = (
  components?: SelectComponentsConfig<any, boolean, GroupBase<any>>
): UseLoadOptionsFailureResult => {
  const [loadFailed, setLoadFailed] = useBoolean(false)

  const latestRequest = useRef(0)

  const onLoadSettled = useCallback((failed: boolean) => setLoadFailed(failed), [setLoadFailed])

  return {
    onLoadSettled,
    latestRequest,
    components: loadFailed ? { ...components, NoOptionsMessage: LoadFailedNoOptionsMessage } : components,
  }
}
